import { onAttach } from '../attach';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';
import { UIView } from '../view';

export interface UIRibbonOptions {
    classes?: UIClassesSpec;
}

export class UIRibbon extends UIView {
    constructor(text: string, options: UIRibbonOptions = {}) {
        super('div', ['ui-ribbon', options.classes]);

        const span = $el.I(text);
        this.ui_add(span);

        if(text.length > 5) {
            onAttach(this, () => {
                requestAnimationFrame(() => {
                    const font_size = parseInt(getComputedStyle(this.root).fontSize!);
                    const width = span.offsetWidth;
                    if(width > 4 * font_size)
                        span.style.fontSize = (font_size / (width / 4 / font_size)) + 'px';
                });
            });
        }
    }
}

